import React, { useState, useContext } from "react";
import { useNavigate, useLocation, Link } from "react-router-dom";
//import { Auth } from "aws-amplify";
//import { Auth } from '@aws-amplify/auth';
import { signIn, signOut, getCurrentUser } from '@aws-amplify/auth';
import { DataContext } from "../../../../../context/DataContext";
import {
  HomeIcon,
  UserCircleIcon,
  ChatBubbleLeftIcon,
  HeartIcon,
  WrenchScrewdriverIcon,
  BellIcon
} from "@heroicons/react/24/outline";

const MOOD_OPTIONS = [
  { key: "", text: "Todos", icon: "" },
  { key: "happy", text: "Alegre", icon: "😊" },
  { key: "neutral", text: "Neutral", icon: "😐" },
  { key: "sad", text: "Triste", icon: "😞" },
  { key: "angry", text: "Molesto", icon: "😡" },
  { key: "anxious", text: "Ansioso", icon: "😨" }
];

const POST_TYPE_OPTIONS = [
  { key: "", text: "Todos" },
  { key: "logro", text: "Logro" },
  { key: "agradecimiento", text: "Agradecimiento" },
  { key: "duda", text: "Duda" },
  { key: "meta", text: "Meta" }
];

const pages = [
  { label: "Suscripciones", to: "/suscripccion" }
];
const settings = ["Mi perfil", "Cerrar sesión"];

const AppBar = () => {
  const navItems = [
    { to: "/wall", label: "Inicio", icon: HomeIcon },
    { to: "/my-wall", label: "Mi perfil", icon: UserCircleIcon },
    { to: "/chatroom", label: "Mi chat", icon: ChatBubbleLeftIcon },
    { to: "/support-network", label: "Red de apoyo", icon: HeartIcon },
    { to: "/alerts", label: "Alertas", icon: BellIcon },
    { to: "/toolbox", label: "Mi caja de herramientas", icon: WrenchScrewdriverIcon }
  ];

  const profileProgress = 70;
  const profileMessage = profileProgress >= 100 ? "Perfil completo" : "Completa tu perfil.";
  const [isOpen, setIsOpen] = useState(false);
  const [showFilters, setShowFilters] = useState(false);
  const [searchValue, setSearchValue] = useState("");
  const [moodFilter, setMoodFilter] = useState("");
  const [postTypeFilter, setPostTypeFilter] = useState("");
  const [topicFilter, setTopicFilter] = useState("");
  const navigate = useNavigate();
  const { userData, setUserData } = useContext(DataContext);
  const location = useLocation();

  const toggleMenu = () => {
    setIsOpen(!isOpen);
  };

  const doSignOut = async () => {
    try {
      //await Auth.signOut();
      await signOut();
      setUserData(null);
      navigate("/login");
    } catch (e) {
      console.log(e);
    }
  };

  const isActive = (path) => {
    const current = location.pathname.replace(/\/+$/, "");
    const target = path.replace(/\/+$/, "");
    return current === target || current.startsWith(`${target}/`);
  };

  const profileAvatar = userData?.attributes?.picture;
  const profileInitial = (userData?.attributes?.name || userData?.attributes?.email || "U").slice(0, 1).toUpperCase();

  const emitFilters = (override = {}) => {
    const detail = {
      search: override.searchValue ?? searchValue,
      mood: override.moodFilter ?? moodFilter,
      postType: override.postTypeFilter ?? postTypeFilter,
      topic: override.topicFilter ?? topicFilter,
    };
    window.dispatchEvent(new CustomEvent("wall-search-update", { detail }));
  };

  React.useEffect(() => {
    emitFilters();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <nav className="green-app-bg sticky top-0 z-40">
      <div className="mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex items-center justify-between h-[74px]">
          <div className="flex items-center">
            <div className="flex-shrink-0">
              <a
                href="#app-bar-with-responsive-menu"
                className="text-white font-bold text-lg sm:text-xl"
              >
                SincronyBot
              </a>
            </div>
            <div className="relative ml-2 sm:ml-4 flex flex-wrap items-center gap-2 w-full sm:w-auto">
              <div className="flex items-center bg-white rounded-full px-3 py-1 shadow-sm w-full sm:w-auto max-w-[60vw] sm:max-w-none h-10 sm:h-auto">
                <input
                  type="text"
                  className="bg-transparent outline-none text-sm text-gray-700 placeholder:text-gray-400 w-full sm:w-56 h-full"
                  placeholder="Buscar en el muro..."
                  value={searchValue}
                  onChange={(e) => {
                    setSearchValue(e.target.value);
                    emitFilters({ searchValue: e.target.value });
                  }}
                />
                <button
                  className="ml-2 w-8 h-8 rounded-full bg-indigo-50 text-indigo-700 border border-indigo-200 hover:bg-indigo-100 flex items-center justify-center"
                  onClick={() => setShowFilters((prev) => !prev)}
                  title={showFilters ? "Ocultar filtros" : "Mostrar filtros"}
                  aria-label={showFilters ? "Ocultar filtros" : "Mostrar filtros"}
                >
                  {showFilters ? "−" : "+"}
                </button>
              </div>
              {showFilters && (
                <div className="absolute top-full left-0 sm:left-auto sm:right-0 mt-2 z-50 w-[280px] sm:w-[360px] bg-white rounded-2xl shadow-2xl border border-gray-200 p-3 space-y-3">
                  <div>
                    <p className="text-xs font-semibold text-gray-600 mb-2">Estado de ánimo</p>
                    <div className="flex flex-wrap gap-2">
                      {MOOD_OPTIONS.map((m) => (
                        <button
                          key={m.key || "all"}
                          className={`px-3 py-1 rounded-full border text-xs ${
                            moodFilter === m.key
                              ? "bg-indigo-50 border-indigo-300 text-indigo-700"
                              : "border-gray-200 hover:bg-gray-100"
                          }`}
                          onClick={() => {
                            setMoodFilter(m.key);
                            emitFilters({ moodFilter: m.key });
                          }}
                        >
                          {m.icon && `${m.icon} `}{m.text}
                        </button>
                      ))}
                    </div>
                  </div>
                  <div>
                    <p className="text-xs font-semibold text-gray-600 mb-2">Tipo de post</p>
                    <div className="flex flex-wrap gap-2">
                      {POST_TYPE_OPTIONS.map((t) => (
                        <button
                          key={t.key || "all"}
                          className={`px-3 py-1 rounded-full border text-xs ${
                            postTypeFilter === t.key
                              ? "bg-indigo-50 border-indigo-300 text-indigo-700"
                              : "border-gray-200 hover:bg-gray-100"
                          }`}
                          onClick={() => {
                            setPostTypeFilter(t.key);
                            emitFilters({ postTypeFilter: t.key });
                          }}
                        >
                          {t.text}
                        </button>
                      ))}
                    </div>
                  </div>
                  <div>
                    <p className="text-xs font-semibold text-gray-600 mb-1">Tema (#)</p>
                    <input
                      className="w-full border border-gray-300 rounded-lg px-3 py-2 text-xs"
                      placeholder="#ansiedad, #autoestima"
                      value={topicFilter}
                      onChange={(e) => {
                        const val = e.target.value.trim().toLowerCase();
                        setTopicFilter(val);
                        emitFilters({ topicFilter: val });
                      }}
                    />
                  </div>
                </div>
              )}
            </div>
            <div className="hidden md:block">
              <div className="ml-14 flex items-baseline space-x-2">
                {pages.map((page) => (
                  <Link
                    key={page.label}
                    to={page.to}
                    className="block px-4 py-2 text-sm text-white hover:bg-gray-100 hover:text-gray-900 w-full text-left"
                    role="menuitem"
                  >
                    {page.label}
                  </Link>
                ))}
              </div>
            </div>
          </div>
          <div className="hidden md:block">
            <div className="ml-4 flex items-center md:ml-6 gap-6">
              <div className="flex items-center gap-3 text-white/90">
                <div className="flex flex-col">
                  <span className="text-xs font-semibold">{profileMessage}</span>
                  <div className="h-2 w-44 bg-white/30 rounded-full overflow-hidden">
                    <div
                      className="h-2 bg-white rounded-full transition-all duration-300"
                      style={{ width: `${profileProgress}%` }}
                      aria-label="Progreso del perfil"
                    />
                  </div>
                </div>
                <span className="text-xs font-semibold">{profileProgress}%</span>
              </div>
              <div className="relative">
                <div>
                  <button
                    className="max-w-xs bg-gray-800 rounded-full flex items-center text-sm focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-offset-gray-800 focus:ring-white"
                    id="user-menu"
                    aria-haspopup="true"
                    onClick={() => setIsOpen(!isOpen)}
                  >
                    <span className="sr-only">Open user menu</span>
                    <div
                      className="h-8 w-8 rounded-full bg-gray-300"
                      style={{
                        backgroundImage: `url('https://picsum.photos/20/20')`,
                      }}
                      alt=""
                    />
                  </button>
                </div>
                {isOpen && (
                  <div className="origin-top-right absolute right-0 mt-2 w-48 rounded-md shadow-lg py-1 bg-white ring-1 ring-black ring-opacity-5">
                {settings.map((setting) =>
                  setting === "Cerrar sesión" ? (
                    <button
                      key={setting}
                      onClick={doSignOut}
                      className="block px-4 py-2 text-sm text-gray-700 hover:bg-gray-100 w-full text-left"
                      role="menuitem"
                    >
                      {setting}
                    </button>
                  ) : (
                    <button
                      key={setting}
                      onClick={() => navigate("/profile")}
                      className="block px-4 py-2 text-sm text-gray-700 hover:bg-gray-100 w-full text-left"
                      role="menuitem"
                    >
                      {setting}
                    </button>
                  )
                )}
              </div>
            )}
          </div>
        </div>
          </div>
          <div className="-mr-2 flex md:hidden">
            <button
              onClick={toggleMenu}
              className="bg-gray-800 inline-flex items-center justify-center p-2 rounded-md text-gray-400 hover:text-white hover:bg-gray-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-offset-gray-800 focus:ring-white"
            >
              <span className="sr-only">Open main menu</span>
              <svg
                className={`${isOpen ? "hidden" : "block"} h-6 w-6`}
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
                aria-hidden="true"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M4 6h16M4 12h16M4 18h16"
                />
              </svg>
              <svg
                className={`${isOpen ? "block" : "hidden"} h-6 w-6`}
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
                aria-hidden="true"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M6 18L18 6M6 6l12 12"
                />
              </svg>
            </button>
          </div>
        </div>
      </div>

      {/* Barra de iconos global (solo iconos + tooltip) */}
      <div className="bg-white shadow-sm border-b border-gray-100">
        <ul className="flex items-center gap-3 px-4 py-2">
          {navItems.map((item) => {
            const Icon = item.icon;
            const active = isActive(item.to);
            const isProfile = item.label === "Mi perfil";
            return (
              <li key={item.label}>
                <Link
                  to={item.to}
                  className={`group relative flex items-center justify-center w-11 h-11 rounded-xl border transition-all duration-200 ${
                    active
                      ? "bg-gradient-to-b from-green-100 to-green-200 text-green-800 border-green-200"
                      : "bg-white text-gray-600 border-transparent hover:border-green-700"
                  }`}
                >
                  {isProfile && profileAvatar ? (
                    <img
                      src={profileAvatar}
                      alt={userData?.attributes?.name || "Mi perfil"}
                      className="w-7 h-7 rounded-full object-cover"
                    />
                  ) : isProfile ? (
                    <div className="w-7 h-7 rounded-full bg-green-100 text-green-800 flex items-center justify-center text-sm font-semibold">
                      {profileInitial}
                    </div>
                  ) : (
                    <Icon className="w-6 h-6" />
                  )}
                  <span className="pointer-events-none absolute left-1/2 -translate-x-1/2 top-full mt-2 whitespace-nowrap rounded-md bg-green-100 text-green-800 text-xs px-2 py-1 opacity-0 group-hover:opacity-100 shadow-sm">
                    {item.label}
                  </span>
                </Link>
              </li>
            );
          })}
        </ul>
      </div>

      {isOpen && (
        <div className="md:hidden">
          <div className="px-2 pt-2 pb-3 space-y-1 sm:px-3">
            {pages.map((page) => (
              <Link
                key={page.label}
                to={page.to}
                className="text-gray-300 hover:bg-gray-700 hover:text-white block px-3 py-2 rounded-md text-base font-medium"
              >
                {page.label}
              </Link>
            ))}
          </div>
          <div className="pt-4 pb-3 border-t border-gray-700">
            <div className="flex items-center px-5">
              <div className="flex-shrink-0">
                <div
                  className="h-8 w-8 rounded-full bg-gray-300"
                  style={{
                    backgroundImage: `url('https://picsum.photos/20/20')`,
                  }}
                  alt=""
                />
              </div>
              <div className="ml-3">
                <div className="text-base font-medium leading-none text-white">
                  Remy Sharp
                </div>
                <div className="text-sm font-medium leading-none text-gray-400">
                  remy.sharp@example.com
                </div>
              </div>
            </div>
            <div className="mt-3 px-2 space-y-1">
              {settings.map((setting) =>
                setting === "Cerrar sesión" ? (
                  <button
                    key={setting}
                    onClick={doSignOut}
                    className="block px-3 py-2 rounded-md text-base font-medium text-gray-400 hover:text-white hover:bg-gray-700 w-full text-left"
                  >
                    {setting}
                  </button>
                ) : (
                  <a
                    key={setting}
                    href="#app-bar-with-responsive-menu"
                    className="block px-3 py-2 rounded-md text-base font-medium text-gray-400 hover:text-white hover:bg-gray-700 w-full text-left"
                  >
                    {setting}
                  </a>
                )
              )}
            </div>
          </div>
        </div>
      )}
    </nav>
  );
};

export default AppBar;
